interface Props {
  label: string
  value: number
  max: number
  color: string
}

export default function StatBar({ label, value, max, color }: Props) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100))
  return (
    <div className="flex items-center gap-2">
      <span className="w-8 text-[10px] font-bold uppercase tracking-wider text-white/50">{label}</span>
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-white/10">
        <div className="hp-bar-fill h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
      <span className="w-9 text-right text-xs font-bold tabular-nums">{value}</span>
    </div>
  )
}
